import React from "react";
import LegalPage from "../../components/LegalPage";

const PDF = "https://customer-assets.emergentagent.com/job_workflow-builder-125/artifacts/c577knxt_Zelaflo_Labs_Refund_Policy.pdf";

export default function RefundPolicy() {
  return (
    <LegalPage
      title="Refund Policy"
      pdfUrl={PDF}
      description="Our commitments regarding refunds, cancellations, and service credits."
      testId="legal-refund-policy"
    />
  );
}
